import type { ReusableContentStoryblok } from "@/generated/sb/sb-types";

import { BloksRoute } from "@/data/routes/bloks.route";
import { BlokProps, StoryblokComponentList } from "@frend-digital/storyblok";

export const ReusableContentBlok = ({
  preview,
  data,
}: BlokProps<ReusableContentStoryblok, BloksRoute["reusableContent"]>) => {
  return <StoryblokComponentList bloks={data ?? []} preview={preview} />;
};
